import { appendIf } from '@btime/helpers'
import { gql, useMutation } from '@apollo/client'
import { useTranslation } from 'react-i18next'

import { cleanRequest } from './cleanRequest'
import { segmentsClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'
import { navigate } from '@reach/router'

const MUTATION = gql`
  mutation UpsertSegments($inputs: [SegmentInput]) {
    upsertSegments(inputs: $inputs) {
      id
    }
  }
`

const validate = (form, setErrors, t) => {
  const errors = form.reduce(
    (errors, item, index) => [
      ...errors,
      ...appendIf(!item.name, { path: [index, 'name'], message: t('validations:required') })
    ],
    []
  )

  setErrors(errors)
  return errors.length === 0
}

export const useSaveSegments = (backToList = false) => {
  const { t } = useTranslation()
  const closeModal = useCloseModal()

  const [request, upsertSegmentsState] = useMutation(MUTATION, {
    refetchQueries: ['Segments'],
    client: segmentsClient
  })

  const handleRequest = async (form, actions) => {
    const inputs = cleanRequest(form)
    const { setErrors } = actions

    const tCombined = key => {
      if (key?.startsWith('validations:')) return t(`validations:${key.replace('validations:', '')}`)
      return t(key)
    }

    const isValid = validate(form, setErrors, tCombined)
    if (!isValid) return

    request({ variables: { inputs } }).then(resp => {
      if (!resp.errors) {
        closeModal()
      }
      if (backToList) {
        navigate('/segmentations')
      }
    })
  }

  return [handleRequest, upsertSegmentsState]
}
